'use client';

import { Stack } from '@chakra-ui/react';

import { SpinnerCircle } from 'ui/SpinnerCircle';
import { Text } from 'ui/Text';

type LoaderProps = {
  bg?: string;
  color?: string;
  text?: string;
};

const PaymentLoader = ({
  bg = 'transparent',
  color = 'white',
  text = ''
}: LoaderProps) => (
  <Stack
    align='center'
    justify='center'
    position='fixed'
    top='0'
    left='0'
    right='0'
    bottom='0'
    bg={bg}
    zIndex='9999'
    gap={{ base: '30px', md: '50px', lg: '70px' }}
    p='30px'
  >
    <Text
      fontSize={{ base: '40px', md: '50px', lg: '60px' }}
      color={color}
      textAlign='center'
    >
      Almost Done
    </Text>
    <SpinnerCircle />
    <Text
      fontSize={{ base: '28px', md: '36px', lg: '42px' }}
      color={color}
      textAlign='center'
    >
      {text}
    </Text>
  </Stack>
);

export default PaymentLoader;
